import clientPaths from './client-path.js'

// 注意事项：包名修改 src\config\secret-key.js里的包名也要修改
const apps = {
  default: {
    clientPath: clientPaths.default,
    schema: 'imee://',
  },
  echo: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dewidfp7zx5np.cloudfront.net' : 'd1ttx9a5vofxx7.cloudfront.net',
    clientPath: clientPaths.echo,
    // 正式 测试 测试
    hosts: ['www.echoapp.chat', 'dewidfp7zx5np.cloudfront.net', 'd1ttx9a5vofxx7.cloudfront.net'],
    // 测试 安卓 苹果
    packages: ['com.example.echo', 'com.chat.whisper', 'com.fh.whisper.chat'],
    schema: 'echo://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.echoapp.chat' : 'd1ttx9a5vofxx7.cloudfront.net',
  },
  joychat: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.joyme.chat' : 'app.test.camfan.chat',
    clientPath: clientPaths.joychat,
    // 正式 正式 测试
    hosts: ['www.joyme.chat', 'app.joyme.chat', 'dr9gc3kyysxu5.cloudfront.net'],
    // 测试 安卓
    packages: ['com.owner.chat', 'com.chat.joychat'],
    schema: 'joychat://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.joyme.chat' : 'dr9gc3kyysxu5.cloudfront.net',
  },
  joyu: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'sev.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
    clientPath: clientPaths.joyu,
    // 正式 测试
    hosts: ['www.mind-link.chat', 'd30296ri52vin5.cloudfront.net'],
    // 测试 安卓
    packages: ['com.example.joyu', 'com.mind.joyu'],
    schema: 'joyu://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
  },
  kiko: {
    apiBaseURL: {
      android: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.fun' : 'app.test.inpulse.fun',
      ios: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.cc' : 'inpulse.test.inpulse.cc',
    },
    clientPath: clientPaths.kiko,
    // 正式 正式 正式 测试
    hosts: ['www.kikoapp.chat', 'www.inpulse.fun', 'app.inpulse.fun', 'app.test.inpulse.fun'],
    // ios测试 苹果正式
    iosPackages: ['com.test.moodlink', 'com.date.moodlink'],
    // 安卓测试 安卓正式 ios测试 苹果正式
    packages: ['com.example.kiko', 'com.live.kiko', 'com.test.moodlink', 'com.date.moodlink'],
    schema: 'kiko://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.kikoapp.chat' : 'app.test.inpulse.fun',
  },
  vava: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.camfan.chat' : 'app.test.camfan.chat',
    clientPath: clientPaths.vava,
    // 正式 正式 正式 测试
    hosts: ['www.vava.chat', 'www.camfan.chat', 'app.camfan.chat', 'app.test.camfan.chat'],
    // ios测试 苹果正式
    iosPackages: ['com.test.coach', 'com.tools.coach'],
    // 测试 安卓 安卓正式 ios测试 苹果正式
    packages: ['com.example.gcc', 'com.client.goparty', 'com.test.coach', 'com.tools.coach'],
    schema: 'imee://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.camfan.chat' : 'app.test.camfan.chat',
  },
  vibeo: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'vbi.vervachat.com' : 'vibeo.test.vervachat.com',
    clientPath: clientPaths.vibeo,
    // 正式 测试
    hosts: ['web.vervachat.com', 'vibeo.test.vervachat.com'],
    // 测试 安卓
    packages: ['com.example.vibeo', 'com.live.vibeo'],
    schema: 'vibeo://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'web.vervachat.com' : 'vibeo.test.vervachat.com',
  },
  whonow: {
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dwogpybf1cxs0.cloudfront.net' : 'd31j2n3w70svmb.cloudfront.net',
    clientPath: clientPaths.whonow,
    // 正式 测试
    hosts: ['www.linkup.chat', 'd31j2n3w70svmb.cloudfront.net'],
    // 测试 安卓
    packages: ['com.example.whonow', 'com.linkup.chat.whonow'],
    schema: 'whonow://',
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.linkup.chat' : 'd31j2n3w70svmb.cloudfront.net',
  },
  vavaWeb: {
    // h5
    packages: ['com.vava.chat.web'],
  },
}

const baseConfig = {
  // 环境类型
  isRelease: process.env.VUE_APP_IS_RELEASE == 1,
  // 图片地址
  imgHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',
  // 右向左语言列表
  rtlLangs: ['ar', 'fa', 'he'],
  // 现有web包
  validWebPackage: ['vavaWeb'],
  // 现有app包
  validAppPackage: ['echo', 'joychat', 'joyu', 'kiko', 'vava', 'vibeo', 'whonow'],
  apps,
  // app包名 [测试 安卓 苹果] 简写，由 apps.packages 自动生成
  packageNameMap: Object.entries(apps).reduce((map, [shortName, app]) => {
    ;(app.packages || []).forEach((pkg) => {
      map[pkg] = shortName
    })
    return map
  }, {}),
}

export default baseConfig
